import React from "react";
import moment from "moment";
import NullableValue from "../../../../../../Utils/renderField/nullableValue";
const verIcon = require("assets/img/icons/ver.png");
const eliminarIcon = require("assets/img/icons/borrar.png");
const editarIcon = require("assets/img/icons/editar.png");

export const PadresPTTable = ({
    padresPT,
    EliminarPadrePT,
    SeleccionarPadrePTEdicion,
}) => {
    return (
        <div className="new-table-wrapper padres-pt__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Fecha de creación</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {padresPT.length === 0 && (
                        <tr>
                            <td colSpan={4} className="text-center">
                                No hay padres de producto terminado para mostrar
                            </td>
                        </tr>
                    )}
                    {padresPT.map((item) => {
                        return (
                            <tr key={item.id}>
                                <td className="text-center">{item.nombre}</td>
                                <td className="text-center">
                                    <NullableValue value={item.creado}>
                                        {moment(item.creado).format(
                                            "DD/MM/YYYY HH:mm",
                                        )}
                                    </NullableValue>
                                </td>
                                <td className="text-center">
                                    <div className="table-actions">
                                        <img
                                            src={editarIcon}
                                            alt="Editar"
                                            className="action_img"
                                            title="Editar"
                                            onClick={() =>
                                                SeleccionarPadrePTEdicion(item)
                                            }
                                        />
                                        <img
                                            src={eliminarIcon}
                                            alt="Eliminar"
                                            className="action_img"
                                            title="Eliminar"
                                            onClick={() =>
                                                EliminarPadrePT(item.id)
                                            }
                                        />
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
